import { FunctionComponent } from 'react';
import GenericIcons from './generics/GenericIcons';

const BloqueEnDesarrollo: FunctionComponent<{
  titulo: string;
  descripcion?: string;
  compacto?: boolean;
}> = ({ titulo, descripcion, compacto = false }) => {
  const mensaje =
    descripcion ?? 'Sección en desarrollo. Próximamente disponible en VisiónDERRED.';
  return (
    <div
      className={`bloque-en-desarrollo${compacto ? ' bloque-en-desarrollo--compacto' : ''}`}>
      <div className='bloque-en-desarrollo-icono vdr-icon-tile' aria-hidden='true'>
        <GenericIcons icon='InfoIcon' className='bloque-en-desarrollo-icono-svg' />
      </div>
      <div className='bloque-en-desarrollo-textos'>
        <h3 className='bloque-en-desarrollo-titulo'>{titulo}</h3>
        <p className='bloque-en-desarrollo-mensaje'>{mensaje}</p>
      </div>
    </div>
  );
};

export default BloqueEnDesarrollo;
